const KboardConstant = {
    /**
     * Source identifiers used in postMessage communication between sdesk and kboard.
     * Must match the values used in wlp-client-react (SolutionDeskConst.SDESK_CONNECT_SOURCE).
     */
    MESSAGE_SOURCE: {
        SDESK: 'sdesk',
        KBOARD: 'kboard',
    },

    /**
     * Message types for cross-tab postMessage communication between sdesk and kboard.
     * Must stay in sync with wlp-client-react (SolutionDeskConst.SDESK_CONNECT_MESSAGE_TYPE).
     *
     * sdesk → kboard (outgoing from sdesk)
     * kboard → sdesk (incoming to sdesk)
     */
    MESSAGE_TYPE: {
        // sdesk → kboard
        SDESK_INIT_CONNECTION: 'SDESK_INIT_CONNECTION',
        SDESK_SEND_CONTEXT: 'SDESK_SEND_CONTEXT',
        SDESK_DISCONNECT: 'SDESK_DISCONNECT',
        SDESK_SEND_SHEET_KNOWLEDGE: 'SDESK_SEND_SHEET_KNOWLEDGE',
        SDESK_UPDATE_THREAD_ID: 'SDESK_UPDATE_THREAD_ID',

        // kboard → sdesk
        KBOARD_CONNECTION_READY: 'KBOARD_CONNECTION_READY',
        KBOARD_SEND_RESULT: 'KBOARD_SEND_RESULT',
        KBOARD_CONNECTION_CLOSED: 'KBOARD_CONNECTION_CLOSED',
        KBOARD_REQUEST_SHEET_KNOWLEDGE: 'KBOARD_REQUEST_SHEET_KNOWLEDGE',
    },

    /**
     * Connection status values for tracking the kboard tab connection state.
     */
    CONNECTION_STATUS: {
        DISCONNECTED: 'DISCONNECTED',
        CONNECTING: 'CONNECTING',
        CONNECTED: 'CONNECTED',
    },

    /**
     * URL path opened in the kboard tab when connecting.
     */
    TAB_PATH: '/mypage',

    /**
     * Retry config for sending the init message to kboard (kboard needs time to load).
     */
    INIT_RETRY: {
        MAX_COUNT: 5,
        INTERVAL_MS: 1000,
    },
};

export default KboardConstant;
